import React, { FC, useState } from 'react';

import * as Sentry from '@sentry/react';
import cn from 'classnames';

import Ratio from '../../pages/CourseProgress/components/Ratio';
import IKImage, { InterfaceIKImage } from '../IKImage/IKImage';
import { Loader } from '../Loader';
import useStyles from './styles';

interface ImageWithLoaderProps extends InterfaceIKImage {
  ratio: number;
  wrapperClass?: string;
  imgWrapperClass?: string;
}

const ImageWithLoader: FC<ImageWithLoaderProps> = ({
  ratio,
  wrapperClass = '',
  imgWrapperClass = '',
  path,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const classes = useStyles();

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = (e) => {
    setIsLoading(false);
    Sentry.captureException(e);
  };

  return (
    <Ratio
      ratio={ratio}
      className={wrapperClass}
      contentWrapperClass={cn(imgWrapperClass, classes.imgWrapper)}
    >
      {isLoading && <Loader global={false} data-testid={`${rest['data-testid']}Loader`} />}
      <IKImage path={path} onLoad={handleLoad} onError={handleError} {...rest} />
    </Ratio>
  );
};

export default ImageWithLoader;
